import type { FC } from 'react';
import React from 'react';

import AccountVehicleCard from '../AccountVehiclesList/AccountVehicleCard/AccountVehicleCard';

import styles from './AccountLoading.module.scss';

const DEFAULT_LOADING_CARDS_COUNT = 3;

type AccountLoadingProps = {
	itemsOnPage?: number;
};

const AccountLoading: FC<AccountLoadingProps> = ({ itemsOnPage = DEFAULT_LOADING_CARDS_COUNT }) => {
	const AccountCardCount = Array.from(Array(itemsOnPage).keys());

	return (
		<div className={styles.accountVehiclesList}>
			{AccountCardCount.map((k) => (
				<AccountVehicleCard key={`loading-card-${k}`} loading className={styles.accountVehicleCard} />
			))}
		</div>
	);
};

export default AccountLoading;
